import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export const commit = (type, payload, options) => {
  store.commit(type, payload, options)
}

export const dispatch = (type, payload, options) => {
  store.dispatch(type, payload, options)
}

export const watch = (prop, callback, options) => {
  return store.watch(state => state[prop], callback, options)
}

export default store
